import { useNavigate } from "react-router-dom";
import { pageToPath } from "../../routes";
import { ContactsPage, HomePage, PartnersPage, SetsPage } from "../components/Pages";
import { PageSeo } from "../components/PageSeo";
import { useBakeryCatalog } from "../context/BakeryCatalogContext";

export function HomeCatalogRoutePage() {
  const {
    loading,
    categories,
    selectedCategory,
    searchQuery,
    filteredDesserts,
    setSearchQuery,
    setSelectedCategory,
    openDetail,
    addToCart
  } = useBakeryCatalog();

  return (
    <>
      <PageSeo page="home" />
      <HomePage
        loading={loading}
        categories={categories}
        selectedCategory={selectedCategory}
        searchQuery={searchQuery}
        filteredDesserts={filteredDesserts}
        onSearchQueryChange={setSearchQuery}
        onSelectCategory={setSelectedCategory}
        onOpenDetail={openDetail}
        onAddToCart={addToCart}
      />
    </>
  );
}

export function SetsCatalogRoutePage() {
  const { sets, openSet } = useBakeryCatalog();

  return (
    <>
      <PageSeo page="sets" />
      <SetsPage sets={sets} onOpenSet={openSet} />
    </>
  );
}

export function PartnersCatalogRoutePage() {
  const navigate = useNavigate();
  const { partners, desserts } = useBakeryCatalog();

  return (
    <>
      <PageSeo page="partners" />
      <PartnersPage
        partners={partners}
        desserts={desserts}
        onNavigateToContacts={() => {
          navigate(pageToPath("contacts"));
        }}
      />
    </>
  );
}

export function ContactsCatalogRoutePage() {
  return (
    <>
      <PageSeo page="contacts" />
      <ContactsPage />
    </>
  );
}
